import React from 'react'
import styled from 'styled-components'
import ProductsList from 'components/newMagic/ProductsList'
import colors from '../../../styles/colors'
import { headerMainStyle, magicContainerStyle, textMainStyle } from '../styled'
import ButtonGetStarted from '../ButtonGetStarted'
import mediaQuery from 'styles/mediaQuery'

const Section = styled.section`
  position: relative;
  width: 100%;
  padding: 60px 0 10px;
  color: ${colors.white};
  ${mediaQuery.desktopMin} {
    padding: 120px 0 10px;
  }
`

const Container = styled.div`
  ${magicContainerStyle};
`

const TitlesWrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.h1`
  ${headerMainStyle};
  color: rgba(25, 25, 25, 1);
  text-align: center;
  margin-bottom: 24px;
`

const Text = styled.p`
  ${textMainStyle};
  color: rgba(141, 143, 152, 1);
  text-align: center;
  margin: 0 auto 24px;
  max-width: 681px;
`

const translations = {
  header: 'Unlock Your Brand’s Potential with Flip MagicOS',
  description:
    'MagicOs is a self-service e-commerce platform that allows brands to tap into the next generation shopping experience powered by shoppers. Apply to start selling your brand on Flip today.',
  buttonLabel: 'Get started',
}

const ContactFormSection = () => (
  <Section id="product">
    <Container>
      <TitlesWrapper>
        <Title>{translations.header}</Title>
        <Text>{translations.description}</Text>
        <ButtonGetStarted
          color="green"
          buttonLabel={translations.buttonLabel}
        />
      </TitlesWrapper>
      <ProductsList shouldShowText />
    </Container>
  </Section>
)

export default ContactFormSection
